export const environment = {
  firebase: {
    apiKey: 'AIzaSyCi6hyMeHbqq6mKLMdWVqVjLg4SQNSbanA',
    authDomain: 'izyfisco-80213.firebaseapp.com',
    projectId: 'izyfisco-80213',
    storageBucket: 'izyfisco-80213.firebasestorage.app',
    messagingSenderId: '1047166020321',
    appId: '1:1047166020321:web:8d1c9a21390f67219a65a0',
    measurementId: 'G-P9V228WY98',
    vapidKey:
      'BAAl96v0j2UhxhDjbaAoMrmgcT4sJqOUp6YxcWEOSKetd0erCk_CyVail6k6V3m5xNvgA54tzK4FXcPgxvhK8Rw',
  },
  tier: 'production',
  production: true,
  backendDomain: 'https://backend.izyfisco.com',
  add_sleep_on_api_call: false,
  version: 'UIL Toscana',
  theme: 'theme-uiltoscana',
  style: 'uiltoscana',
  logoImage: 'caf-uil-logo-recolored.png',
  fcmIcon: '/icons-uiltoscana/icon-72x72.png',
  cookiePolicyUrl: '/cookie-policy', // TODO: add real UIL link
  termsUrl: '/termini-e-condizioni',
  consentVersion: '2026-07',
};
